<template>
  <div class='risk-graph'></div>
</template>

<script>
import RiskGraph from './diversification-risk-graph'

export default {
  props: ['funds', 'activeFund'],
  watch: {
    activeFund: function(newActiveFund) {
      this.riskGraph.highlight(newActiveFund)
    },
    funds: {
      handler: function (newFunds) {
        this.updateGraph(newFunds);
      },
      deep: true
    },
  },
  mounted() {
    this.riskGraph = new RiskGraph(this.$el, this.funds)
    this.updateGraph(this.funds)

    this.riskGraph.on('activate', (symbol) => {
      this.$emit('activateFund', symbol)
    })
  },
  methods: {
    updateGraph(funds) {
      this.riskGraph.update(funds)
    }
  }
}
</script>
